/** 
 * This function avoids the modals shown on document load to prompt again
 * when the form is submitted to a next step.
 */ 
export function cleanFormQueryParams() {
	const form = document.querySelector( '.ime' );
	const url = form.action.replace( /\?.*#/, '#' );
	form.action = url;
}
